import React from 'react'
import styles from './StatusBar.module.css'
import { StatusBarItem } from './StatusBarItem'

export function StatusBar({statuses}) {
  return (
    statuses &&
    <div className={styles.progressBarWindow}>
      <div className={styles.progressBarWrapper}>
        {statuses.map((displayedStatus, index) => {
            return <StatusBarItem status={{
              singleByType: statuses.filter(status => status.type === displayedStatus.type).length === 1,
              ...displayedStatus
            }}
                                  index={index}
                                  key={`${displayedStatus.type} ${displayedStatus.deliveryPointNumber} ${displayedStatus.intermediatePointNumber}`}
            />;
          }
        )}
      </div>
    </div>
  )
}
